/**
 * 模块: Keyword Replacement Columns
 * 职责: 关键词表格替换率列定义
 * 限制: <280行
 */

import React from 'react';
import { Tooltip } from 'antd';
import type { ColumnType } from 'antd/es/table';
import { renderPercent, metricSorter } from './columnUtils';

/**
 * 替换率相关列（Top3替换率、Top1/2/3替换率、保持率、转化优势）
 */
export const replacementColumns: ColumnType<any>[] = [
  {
    title: <Tooltip title="每次周期更新时，Top3位置中平均有多少比例发生替换。数值越高，竞争越激烈">Top3替换率</Tooltip>,
    dataIndex: ['metrics', 'replacement_rate'],
    key: 'replacement_rate',
    align: 'center',
    className: 'replacement-rate-column',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'replacement_rate'),
  },
  {
    title: <Tooltip title="Top1位置发生替换的概率">Top1替换率</Tooltip>,
    dataIndex: ['metrics', 'top1_replacement_rate'],
    key: 'top1_replacement_rate',
    align: 'center',
    className: 'replacement-rate-column',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'top1_replacement_rate'),
  },
  {
    title: <Tooltip title="Top2位置发生替换的概率">Top2替换率</Tooltip>,
    dataIndex: ['metrics', 'top2_replacement_rate'],
    key: 'top2_replacement_rate',
    align: 'center',
    className: 'replacement-rate-column',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'top2_replacement_rate'),
  },
  {
    title: <Tooltip title="Top3位置发生替换的概率">Top3替换率</Tooltip>,
    dataIndex: ['metrics', 'top3_replacement_rate'],
    key: 'top3_replacement_rate',
    align: 'center',
    className: 'replacement-rate-column',
    render: (value: number) => renderPercent(value, { excellent: 60, good: 40, moderate: 20 }),
    sorter: (a: any, b: any) => metricSorter(a, b, 'top3_replacement_rate'),
  },
  {
    title: <Tooltip title="排名位置的整体稳定性（加权平均）">加权保持率</Tooltip>,
    dataIndex: ['metrics', 'position_retention'],
    key: 'position_retention',
    align: 'center',
    className: 'retention-rate-column',
    render: (value: number) => {
      if (value === null || value === undefined) return '-';
      const percent = value * 100;
      return renderPercent(percent, { excellent: 80, good: 60, moderate: 40 });
    },
    sorter: (a: any, b: any) => metricSorter(a, b, 'position_retention'),
  },
  {
    title: <Tooltip title="Top1位置的稳定性，100%表示完全稳定">Top1保持率</Tooltip>,
    dataIndex: ['metrics', 'top1_retention'],
    key: 'top1_retention',
    align: 'center',
    className: 'retention-rate-column',
    render: (value: number) => {
      if (value === null || value === undefined) return '-';
      const percent = value * 100;
      return renderPercent(percent, { excellent: 80, good: 60, moderate: 40 });
    },
    sorter: (a: any, b: any) => metricSorter(a, b, 'top1_retention'),
  },
  {
    title: <Tooltip title="Top2位置的稳定性，100%表示完全稳定">Top2保持率</Tooltip>,
    dataIndex: ['metrics', 'top2_retention'],
    key: 'top2_retention',
    align: 'center',
    className: 'retention-rate-column',
    render: (value: number) => {
      if (value === null || value === undefined) return '-';
      const percent = value * 100;
      return renderPercent(percent, { excellent: 80, good: 60, moderate: 40 });
    },
    sorter: (a: any, b: any) => metricSorter(a, b, 'top2_retention'),
  },
  {
    title: <Tooltip title="Top3位置的稳定性，100%表示完全稳定">Top3保持率</Tooltip>,
    dataIndex: ['metrics', 'top3_retention'],
    key: 'top3_retention',
    align: 'center',
    className: 'retention-rate-column',
    render: (value: number) => {
      if (value === null || value === undefined) return '-';
      const percent = value * 100;
      return renderPercent(percent, { excellent: 80, good: 60, moderate: 40 });
    },
    sorter: (a: any, b: any) => metricSorter(a, b, 'top3_retention'),
  },
  {
    title: <Tooltip title="转化效率优势系数">转化优势</Tooltip>,
    dataIndex: ['metrics', 'conversion_advantage'],
    key: 'conversion_advantage',
    align: 'center',
    render: (value: number) => value?.toFixed(2),
    sorter: (a: any, b: any) => metricSorter(a, b, 'conversion_advantage'),
  },
];

